import React, { useState, useEffect, useRef } from 'react';

interface CountdownRefreshProps {
  duration: number;
  title?: string;
  onExpire?: () => void;
}

const CountdownRefresh: React.FC<CountdownRefreshProps> = ({ duration, title, onExpire }) => {
  const [timeLeft, setTimeLeft] = useState<number>(duration);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const formatTime = (sec: number) => {
    const minutes = Math.floor(sec / 60);
    const seconds = sec % 60;
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(minutes)}:${pad(seconds)}`;
  };

  const percentLeft = Math.round((timeLeft / duration) * 100);

  useEffect(() => {
    intervalRef.current = setInterval(() => setTimeLeft(prev => prev - 1), 1000);
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  }, [duration]);

  useEffect(() => {
    if (timeLeft <= 0) {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (onExpire) onExpire();
    }
  }, [timeLeft, onExpire]);

  return (
    <div className="countdown">
      {title && <div className="countdown-title small">{title}</div>}
      <div className="countdown-time small">
        {formatTime(timeLeft <= 0 ? 0 : timeLeft)}
      </div>
      <div className="countdown-bar">
        <div
          className={`countdown-bar__progress ${
            percentLeft <= 20 ? 'bar-low' : percentLeft <= 50 ? 'bar-medium' : 'bar-high'
          }`}
          style={{ width: `${percentLeft > 0 ? percentLeft : 0}%` }}
        />
      </div>
    </div>
  );
};

export default CountdownRefresh;
